import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { transform } from 'ol/proj';
import { getformitemsdata, formfileHandle, getformListItemsdatas, getImg, getformatstruct } from "@/utils/utils";
import slidedata from '@/view/map/hdmconfigv2/slidedata';
import headertop from '@/view/map/hdmconfigv2/header';
import pointdata from '@/view/map/hdmconfigv2/pointdata';
import typedata from '@/view/map/hdmconfigv2/typedata';
import mapv2assembly from '@/view/map/hdmconfigv2/map';
import mapmodule from '@/view/map/hdmconfigv2/supermap';
import maptools from '@/view/map/hdmconfigv2/maptools';
import cdata from './common.js';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import axios from 'axios';
let _ = require('lodash');
import routetype from '@/view/map/hdmconfigv2/routetype';
import routedata from '@/view/map/hdmconfigv2/routedata';
import dragcontent from '@/view/map/hdmconfigv2/dragcontent';
import domeditor from '@/view/map/hdmconfigv2/domeditor';
import sourcematerial from '@/view/map/hdmconfigv2/sourcematerial';
import mapdecoration from '@/view/map/hdmconfigv2/mapdecoration';
import * as turf from '@turf/turf';
export default {
  name: 'mapconfigv2',
  components: {
    headertop,
    slidedata,
    mapv2assembly,
    pointdata,
    typedata,
    mapmodule,
    maptools,
    routetype,
    routedata,
    dragcontent,
    domeditor,
    sourcematerial,
    mapdecoration
  },
  meta: {
    title: '地图配置页'
  },
  data() {
    return {
      viewInfo: {},
      isMobile: false,
      alldata: {},
      // state存储数据
      viewdata: {},
      // state存储view数据
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      structList: [],
      // 地图表单结构数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      query: '',
      // 路由参数集合
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      isAdd: true,
      // 地图设置添加、编辑标志
      mapgeojson: {},
      senior: {},
      // 高级设置字段集合
      style: {},
      // 样式对象集合
      rules: {},
      // 地图设置表单涉及必填的字段校验规则
      defaultpform: {},
      pform: {},
      // 地点表单数据
      pformlabel: {},
      // 地点表单结构标题集合
      pformoption: {},
      // 地点表单结构默认选择项值集合
      pformfield: {},
      // 地点表单校验集合
      pstructList: [],
      // 地点表单结构数据
      pList: [],
      // 添加或编辑地点表单数据时列表
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      coordinate: '',
      // 当前点击经纬度
      pointType: '',
      // 点位设置点击操作类型
      pointList: [],
      // 点位列表数据
      pisAdd: true,
      // 点位添加或编辑标识
      mappointList: [],
      // 传入地图组件点位数据
      mapform: {
        deptId: '',
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 地图配置列表查询字段
      maptotalrow: 0,
      // 地图配置列表总数据
      mapList: [],
      // 地图配置列表数据
      mapoptions: [],
      // 地图配置列表名称集合 用于分类所属地图字段
      mapType: '',
      // 分类设置点击操作类型
      tisAdd: true,
      // 分类添加或编辑标识
      tform: {},
      // 分类表单数据
      tformlabel: {},
      // 分类表单结构标题集合
      tformoption: {},
      // 分类表单结构默认选择项值集合
      tformfield: {},
      // 分类表单校验集合
      tstructList: [],
      // 分类表单结构数据
      tpList: [],
      // 添加或编辑分类表单数据时列表
      defaulttform: {},
      // 分类默认form数据
      typeList: [],
      // 分类列表数据
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      // 地图图层相关数据
      maplayer: {
        tiles: false,
        // 是否显示切片地图
        json: false,
        // 是否显示geojson图层
        static: false,
        // 是否显示静态图片图层
        staticimage: '',
        // 静态图片路径
        geojson: {},
        // geojson数据
        drawelement: {},
        // 绘制元素数据
        shadow: {} // 投影数据
      },
      drawinfo: {
        toolsIndex: 9999,
        showtranfer: false,
        linestyle: {},
        currentTextstyle: {},
        textstyle: {},
        currentList: [],
        currentCoordinate: [],
        drawtextblocksum: 0,
        deleteList: [],
        drawJson: ''
      },
      isloadingmap: false,
      // 可加载地图标识
      jsonOption: {},
      streetcode: [],
      // 乡镇街道code
      cTemplateScore: 0,
      // 当前地图模版
      culturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c'
      },
      // 非遗项目表单字段
      culturalformV2: {
        formId: 'cultural_heritage_project_v2',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a8c2d1023ccb36763e58ee6db1e590218'
      },
      // 非遗项目表单字段
      culturaltransferList: [],
      // 非遗项目穿梭需要的数据
      mainActive: false,
      maprouteType: '',
      // 路线分类设置点击操作类型
      rtisAdd: true,
      // 路线分类添加或编辑标识
      rtform: {},
      // 路线分类表单数据
      rtformlabel: {},
      // 路线分类表单结构标题集合
      rtformoption: {},
      // 路线分类表单结构默认选择项值集合
      rtformfield: {},
      // 路线分类表单校验集合
      rtstructList: [],
      // 路线分类表单结构数据
      rtList: [],
      // 添加或编辑路线分类表单数据时列表
      defaultrtform: {},
      // 路线分类默认form数据
      rtypeList: [],
      // 路线分类列表数据
      rtypeform: {
        formId: '1626580',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 路线分类列表查询字段
      defaultrform: {},
      rform: {},
      // 路线表单数据
      rformlabel: {},
      // 路线表单结构标题集合
      rformoption: {},
      // 路线表单结构默认选择项值集合
      rformfield: {},
      // 路线表单校验集合
      rstructList: [],
      // 路线表单结构数据
      rList: [],
      // 添加或编辑路线表单数据时列表
      routeform: {
        formId: '1626576',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9',
        orderType: 'asc'
      },
      // 路线查询字段集合
      routehType: '',
      // 路线设置点击操作类型
      routeList: [],
      // 路线列表数据
      risAdd: true,
      // 路线添加或编辑标识
      timer: null,
      defaultpicImg: require('@/assets/mapv2/defaultImage.jpg'),
      domeditorflag: false,
      dragNode: {},
      // dom编辑器数据 List PC端 appList移动端
      editorData: {
        List: [],
        appList: [],
        pcwidth: 0,
        pcheight: 0
      },
      ceditorData: [],
      // dom编辑器存放当前数据
      cMapShadowData: {},
      // 存放当前的地图投影数据
      sourcestructList: [],
      // 存放素材字段数据
      dragData: {} // 拖拽种类  图片、素材库
    };
  },
  created() {
    if (process.env.NODE_ENV === 'production') this.login();
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    typeList: {
      handler(val) {
        if (this.cTemplateScore === 1) {
          this.culturalList.forEach(elem => {
            let type = this.typeList.find(child => {
              return child.itemformdata.title === elem.itemformdata.level;
            });
            if (type && type.itemformdata.icon.length > 0) elem.itemformdata.icon = type.itemformdata.icon[0].fileUrl;
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.query = this.$route.query;
    this.alldata = this.mapv2info;
    this.viewdata = this.mapv2info.viewCount;
    this.getMapList();
    this.getMapData();
    this.validRules();
    this.pointStruct();
    this.typeStruct();
    this.routetypeStruct();
    this.routeStruct();
    this.getStructForm();
    this.getRobotsByUnit();
  },
  methods: {
    ...mapMutations(['SET_MAPINFOITEM', 'SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPVIEWITEM', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLE', 'SET_MAPSTYLEITEM', 'SET_COORDINATE', 'SET_MAPGEOJSON', 'SET_MAPDRAWLAYER', 'SET_MAPSCREEN', 'SET_MAPSCREENITEM', 'SET_MAPSENIORTIEM']),
    login() {
      this.$api.autoLogin().then(res => {
        localStorage.setItem('mapconfigdata', res);
      });
    },
    percentageChange(val) {
      let scale = val / 100;
      this.$refs.mapmodule.percentageChange(scale);
    },
    /**
     * 获取地图列表 配置页分类添加时用到
     */
    getMapList() {
      let that = this;
      this.mapform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.mapform).then(res => {
        // console.log(res);
        this.maptotalrow = res.totalRow;
        this.mapList = [];
        this.mapoptions = [{
          title: '请选择',
          onlyid: ''
        }];
        if (this.maptotalrow > 0) {
          that.mapList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            that.mapoptions.push({
              title: itemformat.title,
              onlyid: itemformat.onlyid
            });
            return item;
          });
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        console.log(`this.sList`, this.sList);
        this.isAdd ? this.addlogic(this.formatData) : this.editlogic(this.formatData);
        this.gettypeList();
      });
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, '177623', this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          // 判断jsontxt数据form长度 是添加 还是编辑 地图设置数据
          that.jsonOption = {
            ...JSON.parse(formatData.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
          };
          console.log(that.jsonOption);
          if (that.jsonOption.screen && Object.keys(that.jsonOption.screen).length > 0) {
            that.SET_MAPSCREEN(that.jsonOption.screen);
            let screenData = that.jsonOption.screen.pc;
            Object.keys(screenData).forEach(item => {
              that.jsonOption[item] = screenData[item];
            });
          }
          that.SET_MAPVIEW(that.jsonOption.view);
          that.viewInfo = that.jsonOption.view;
          that.SET_MAPGEOJSON(that.jsonOption.geojson);
          that.isAdd = Object.keys(that.jsonOption.style).length === 0 ? true : false;
          // 处理地图view相关字段
          that.getFormStruct();
        }
      });
    },
    /**
     * 配置页添加逻辑处理
     */
    addlogic(data) {
      this.maplayer.tiles = true;
      this.maplayer.json = true;
      console.log('添加');
      console.log(data);
      // 处理所属区域view字段值

      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.mapviewhandle(this.jsonOption.view);
      this.form.mapmodetype = this.formoption.mapmodetype[0].title;
      this.form.scale = false;
      this.form.rotate = false;
      this.form.translate = false;
      this.form.showtype = 1;
      this.form.showlistflag = 2;
      this.form.typeall = true;
      this.form.typeallname = '全部';
      this.form.routebutton = 2;
      this.form.routebuttontext = '路线推荐';
      this.form.routelinetype = 1;
      this.senior.visit = false;
      this.senior.visitname = '平台浏览量';
      this.senior.effect = false;
      this.form.visits = 0;
      this.form.customvisits = 0;
      this.form.filltype = this.formoption.filltype[0].title;
      this.form.fillimageindex = 1;
      this.form.allroutepreview = 2;
      this.SET_MAPSTYLEITEM({
        showtype: this.form.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlistflag: this.form.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        routebutton: this.form.routebutton
      });
      this.SET_MAPSTYLEITEM({
        routebuttontext: this.form.routebuttontext
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.SET_MAPSTYLEITEM({
        allroutepreview: this.form.allroutepreview
      });
      this.SET_MAPSENIORTIEM({
        visit: this.senior.visit
      });
      this.SET_MAPSENIORTIEM({
        visitname: this.senior.visitname
      });
      this.SET_MAPSENIORTIEM({
        effect: this.senior.effect
      });
      this.SET_MAPFORM(this.form);
      this.culturalHandle();

      // 获取非遗项目数据
      this.SET_MAPDRAWLAYER(this.drawinfo);
      this.mapjsonhandle();
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      this.maplayer.tiles = true;
      this.maplayer.json = true;
      this.maplayer.static = false;
      console.log('编辑');
      console.log(data);
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      console.log(this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlistflag = this.jsonOption.style.showlistflag ? this.jsonOption.style.showlistflag : 2;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.translate = this.jsonOption.view.translate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : '全部';
      this.form.routebutton = this.jsonOption.style.routebutton ? this.jsonOption.style.routebutton : 2;
      this.form.allroutepreview = this.jsonOption.style.allroutepreview ? this.jsonOption.style.allroutepreview : 2;
      if (this.jsonOption.style.routebuttontext) this.form.routebuttontext = this.jsonOption.style.routebuttontext;
      this.form.routelinetype = this.jsonOption.style.routelinetype ? this.jsonOption.style.routelinetype : 1;
      this.form.translate = this.jsonOption.view.translate;
      if (this.form.fillcolor) this.form.fillcolor = [...JSON.parse(this.form.fillcolor.replace(/(<\/?p.*?>)/gi, ''))];
      this.form.fillimageindex = this.form.fillimageindex && this.form.fillimageindex !== '' ? Number(this.form.fillimageindex) : 1;
      if (this.jsonOption.style.routemoveicon !== undefined && this.jsonOption.style.routemoveicon.length > 0) {
        this.form.routemoveicon = this.jsonOption.style.routemoveicon;
        this.SET_MAPSTYLEITEM({
          routemoveicon: this.form.routemoveicon
        });
      }
      this.senior.visit = this.jsonOption.senior.visit ? this.jsonOption.senior.visit : false;
      this.senior.effect = this.jsonOption.senior.effect ? this.jsonOption.senior.effect : false;
      if (this.form.visits === undefined || this.form.visits === '') this.form.visits = 0;
      if (this.form.customvisits === undefined || this.form.customvisits === '') this.form.customvisits = 0;
      if (this.jsonOption.senior.visitname !== undefined) this.senior.visitname = this.jsonOption.senior.visitname;
      if (this.jsonOption.senior.visitname === undefined) this.senior.visitname = '平台浏览量';
      if (this.form.static_img && this.form.static_img.length > 0) this.maplayer.staticimage = getImg(this.form.static_img[0]);
      if (this.form.mapmodetype === this.formoption.mapmodetype[1].title && this.form.filltype === this.formoption.filltype[1].title && this.form.fillclipimage !== '') {
        this.form.fillclipimage = this.form.fillclipimage.replace(/(<\/?p.*?>)/gi, '').match(/src="([^"]*)"/i)[1];
        this.maplayer.staticimage = this.form.fillclipimage;
      }
      if (this.form.componentjson !== undefined) {
        let comptdata = this.form.componentjson.replace(/(<\/?p.*?>)/gi, '');
        if (comptdata !== '') {
          this.editorData = JSON.parse(comptdata);
          this.ceditorData = _.cloneDeep(this.editorData.List);
          this.form.pcwidth = this.editorData.pcwidth;
          this.form.pcheight = this.editorData.pcheight;
          console.log(`this.ceditorData`, this.ceditorData);
        }
      }
      if (this.form.background_img && this.form.background_img.length > 0) this.maplayer.tiles = false;
      if (this.maplayer.staticimage !== '') this.maplayer.static = true;
      if (this.form.bgaudioicon !== undefined && this.form.bgaudioicon.length === 2) {
        this.form.bgaudiostarticon = [this.form.bgaudioicon[0]];
        this.form.bgaudioendicon = [this.form.bgaudioicon[1]];
      }
      if (this.form.viewShadow !== undefined && this.form.viewShadow.length > 0 && this.form.viewShadow[0].val === '显示') {
        const shadowFlag = this.form.viewShadow[0].val === '显示' ? true : false;
        this.maplayer.shadow = {
          shadowFlag: shadowFlag,
          data: this.form.mapShadow
        };
        this.form.viewShadow = this.form.viewShadow[0].val === '显示' ? '显示' : '';
      } else {
        this.form.viewShadow = '';
      }
      console.log(`this.form`, this.form);
      this.SET_MAPFORM(this.form);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.form.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlistflag: this.form.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        routebutton: this.form.routebutton
      });
      this.SET_MAPSTYLEITEM({
        routebuttontext: this.form.routebuttontext
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.SET_MAPSTYLEITEM({
        allroutepreview: this.form.allroutepreview
      });
      this.SET_MAPSENIORTIEM({
        visit: this.senior.visit
      });
      this.SET_MAPSENIORTIEM({
        visitname: this.senior.visitname
      });
      this.SET_MAPSENIORTIEM({
        effect: this.senior.effect
      });
      this.style = this.jsonOption.style;
      console.log(`this.style`, this.style);
      console.log(`this.mapv2info`, this.mapv2info.style);
      this.style.typeall = this.form.typeall;
      this.style.typeallname = this.form.typeallname;
      this.style.routebutton = this.form.routebutton;
      this.style.routebuttontext = this.form.routebuttontext;
      this.style.allroutepreview = this.form.allroutepreview;
      this.senior = this.jsonOption.senior;
      console.log(`this.senior`, this.senior);
      this.culturalHandle();
      this.mapjsonhandle();
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = Number(center[0]);
      this.form.centerXmax = Number(center[0]) + 20;
      this.form.centerXmin = Number(center[0]) - 20;
      this.form.centerY = Number(center[1]);
      this.form.centerYmax = Number(center[1]) + 20;
      this.form.centerYmin = Number(center[1]) - 20;
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    mapjsonhandle() {
      // 是否含有乡镇街道
      // 用来判断是数组 证明包含多个geojson文件
      if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Array]' && this.jsonOption.geojson[0].code) {
        this.streetcode = this.jsonOption.geojson.map(item => {
          return item.code;
        });
      } else if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Object]' && this.jsonOption.geojson.code) {
        this.streetcode = [this.jsonOption.geojson.code];
      }
      let adcode = this.jsonOption.view.adcode;
      console.log(`this.streetcode`, this.streetcode);
      if (this.streetcode.length > 0) {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let jsondata = res.data;
            let filterJson = [];
            this.streetcode.forEach(street => {
              jsondata.features.forEach(feature => {
                if (Number(feature.properties.code) === Number(street)) filterJson.push(feature);
              });
            });
            jsondata.features = filterJson;
            if (this.viewInfo.center === undefined || this.viewInfo.center[0] === null) {
              const bbox = turf.bbox(jsondata);
              this.viewInfo.center = jsondata.features[0].properties.centroid;
              this.viewInfo.extent = bbox;
              this.form.transform_extent = bbox.join(',');
            }
            this.maplayer.geojson = jsondata;
            this.isloadingmap = true;
          }
        }).catch(error => {});
        return;
      }

      // 自定义json数据
      if (this.jsonOption.view.adcode === 'region') {
        let geojson = _.cloneDeep(this.jsonOption.geojson);
        let datacoord = geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
        });
        geojson.features[0].geometry.coordinates[0] = changedata;
        this.maplayer.geojson = geojson;
      }
      this.isloadingmap = true;
      console.log(`this.isloadingmap`, this.isloadingmap);
    },
    culturalHandle() {
      // 判断当前地图模版 score  0标准模版  1非遗模版
      console.log(this.formatData);
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.form.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      // 若标准模版 且 listStyleIndex 0 需重置为1
      if (this.style.listStyleIndex === 0 && this.cTemplateScore === 0) this.style.listStyleIndex = 1;
      if (this.jsonOption.drawlayer) {
        this.jsonOption.drawlayer.toolsIndex = 9999;
        this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
        this.maplayer.drawelement = this.jsonOption.drawlayer;
      } else {
        this.SET_MAPDRAWLAYER(this.drawinfo);
      }
    },
    /**
     * 上传地图基本选项操作
     */
    basicHandle(val) {
      this.SET_MAPFORMITEM(val);
      Object.keys(val).forEach(key => {
        if (key === 'minZoom') this.form.static_map_min_level = val.minZoom;
        if (key === 'maxZoom') this.form.static_map_max_level = val.maxZoom;
        if (key === 'zoom') this.form.current_level = val.zoom;
        if (key === 'minZoom' || key === 'maxZoom' || key === 'zoom') {
          this.SET_MAPVIEWITEM(val);
        }
        if (key === 'centerX' || key === 'centerY') {
          this.form.map_center = [this.setFixed(this.form.centerX, 6), this.setFixed(this.form.centerY, 6)];
          this.SET_MAPVIEWITEM({
            center: [this.setFixed(this.form.centerX, 6), this.setFixed(this.form.centerY, 6)]
          });
          /* 若调整地图center 添加调整标识 */
          this.form.centerflag = true;
        }
        if (key === 'scale') this.SET_MAPVIEWITEM({
          scale: val.scale
        });
        if (key === 'rotate') this.SET_MAPVIEWITEM({
          rotate: val.rotate
        });
        if (key === 'translate') this.SET_MAPVIEWITEM({
          translate: val.translate
        });
        if (key === 'typeall') {
          this.SET_MAPSTYLEITEM(val);
          this.changeTypeOrder(val.typeall);
        }
        if ('showtype,showlistflag,typeallname,routebutton,routebuttontext,routelinetype,allroutepreview'.includes(key)) this.SET_MAPSTYLEITEM(val);
      });
    },
    setFixed(val, len) {
      return val.toFixed(len);
    },
    /**
     * 上传图片操作
     */
    fileHandle(val) {
      console.log(val);
      Object.keys(val).forEach(key => {
        if (key === 'background_img') this.maplayer.tiles = false;
        if (key === 'static_img' || key === 'app_static_img') {
          const mapimage = val.static_img || val.app_static_img;
          this.maplayer.staticimage = mapimage.length === 0 ? '' : getImg(mapimage[0]);
        }
        if (key === 'fillimage') {
          this.form.fillimageindex = val[key].length === 0 ? 1 : '';
          this.SET_MAPFORMITEM({
            fillimageindex: this.form.fillimageindex
          });
        }
        if (key === 'bgaudiostarticon') this.form.bgaudioicon[0] = val[key][0];
        if (key === 'bgaudioendicon') this.form.bgaudioicon[1] = val[key][0];
      });
    },
    /**
     * 保存操作
     */
    saveHandle() {
      console.log(this.form);
      console.log(this.mapv2info);
      this.$refs.mapmodule.saveDrawHandle();
      let valid = true;
      let errorArr = [];
      if (this.form.mapmodetype === this.formoption.mapmodetype[1].title) {
        // 填充图片选项下操作
        if (this.form.filltype === this.formoption.filltype[1].title && this.form.fillclipimage === '') {
          ElMessage({
            message: '填充图片请点击确定按钮',
            type: 'warning'
          });
          return;
        }
        delete this.rules.static_img;
      }
      Object.keys(this.rules).forEach(item => {
        let rulesitem = this.rules[item][0];
        if (rulesitem.type === 'string' && this.form[item] === '' || rulesitem.type === 'img' && this.form[item].length === 0) {
          valid = false;
          errorArr.push(rulesitem.message);
        }
      });
      if (valid) {
        this.saveMapconfig();
      } else {
        ElMessage({
          message: errorArr[0],
          type: 'warning'
        });
      }
    },
    /**
     * 保存数据至地图管理表单
     */
    saveMapconfig() {
      console.log(this.form);
      console.log(this.sList);
      console.log(this.mapv2info);
      console.log(`editorData`, this.editorData);
      console.log(`ceditorData`, this.ceditorData);
      if (Object.keys(this.mapv2info.screen).length > 0) {
        let editInfo = {
          style: _.cloneDeep(this.mapv2info.style),
          view: _.cloneDeep(this.mapv2info.view),
          senior: _.cloneDeep(this.mapv2info.senior),
          drawlayer: _.cloneDeep(this.mapv2info.drawlayer)
        };
        this.isMobile ? this.SET_MAPSCREENITEM({
          app: _.cloneDeep(editInfo)
        }) : this.SET_MAPSCREENITEM({
          pc: _.cloneDeep(editInfo)
        });
      }
      let dataList = [];
      let jsonOption = Object.assign({}, this.mapv2info);
      if (Object.keys(this.mapv2info.screen).length > 0) {
        jsonOption.screen.app.view.extent = jsonOption.screen.pc.view.extent;
      }
      delete jsonOption.form;
      delete jsonOption.routeSources;
      delete jsonOption.routeCurve;
      console.log(jsonOption);
      let form = _.cloneDeep(this.form);
      form.jsontxt = `<p element-id=\"init\" style="display: none;">${JSON.stringify(jsonOption)}</p>`;
      /* 表单更新的新字段 兼容处理 */
      let isExistFillalias = this.sList.find(item => {
        return item.alias === 'filltype';
      });
      if (isExistFillalias !== undefined) {
        form.fillcolor = `<p element-id=\"init\" style="display: none;">${JSON.stringify(form.fillcolor)}</p>`;
        if (form.fillclipimage !== '') form.fillclipimage = `<p element-id=\"init\" style="display: none;"><img src="${form.fillclipimage.replace(/\+/g, '%2B')}"></p>`;
      }
      /* 新字段 图片组件文件 */
      let isExistComponentJson = this.sList.find(item => {
        return item.alias === 'componentjson';
      });
      if (isExistComponentJson !== undefined) {
        this.editorData.pcwidth = window.innerWidth;
        this.editorData.pcheight = window.innerHeight;
        if (this.editorData.List.length > 0) {
          this.editorData.List.forEach(item => {
            if (item.data.url !== undefined && item.data.url !== '') item.data.url = encodeURIComponent(item.data.url);
          });
        }
        if (this.editorData.appList.length > 0) {
          this.editorData.appList.forEach(item => {
            if (item.data.url !== undefined && item.data.url !== '') item.data.url = encodeURIComponent(item.data.url);
          });
        }
        form.componentjson = `<p element-id=\"init\" style="display: none;">${JSON.stringify(this.editorData)}</p>`;
      }
      let mapShadow = this.sList.find(item => {
        return item.alias === 'mapShadow';
      });
      if (mapShadow !== undefined && Object.keys(this.cMapShadowData).length !== 0) {
        form.mapShadow = this.cMapShadowData.data;
        form.viewShadow = !this.cMapShadowData.shadowFlag ? '' : '显示';
      }
      console.log(`form`, form);
      Object.keys(form).forEach(elem => {
        this.sList.forEach(child => {
          if (elem === child.alias) {
            switch (child.compt) {
              case 'imagebox':
              case 'fileupload':
                child.values = formfileHandle(form[elem], child.compt, this.query.uid);
                break;
              case 'detailcombox':
                child.formDataList = form[elem];
                delete child.values;
                break;
              default:
                child.values[0].val = form[elem];
                break;
            }
            dataList.push(child);
          }
        });
      });
      console.log(dataList);
      // return
      this.$api.editForm(this.query.fid, this.query.formUserId, encodeURI(JSON.stringify(dataList)), this.cformUser.formId).then(res => {
        ElMessage({
          message: '保存成功',
          type: 'success'
        });
      });
    },
    validRules() {
      // rules
      this.rules = {
        title: [{
          required: true,
          message: '请输入基础设置的地图名称',
          type: 'string'
        }],
        background_img: [{
          required: true,
          message: '请上传基础设置的背景图片',
          type: 'img'
        }],
        mapmodetype: [{
          required: true,
          message: '请选择地图设置的地图类型',
          type: 'string'
        }],
        static_img: [{
          required: true,
          message: '请上传地图设置的静态地图图片',
          type: 'img'
        }],
        current_level: [{
          required: true,
          message: '请输入地图设置的层级',
          type: 'string'
        }],
        static_map_min_level: [{
          required: true,
          message: '请输入地图设置的最小层级',
          type: 'string'
        }],
        static_map_max_level: [{
          required: true,
          message: '请输入地图设置的最大层级',
          type: 'string'
        }],
        map_center: [{
          required: true,
          message: '请输入地图设置的位置',
          type: 'string'
        }],
        transform_extent: [{
          required: true,
          message: '请输入地图坐标范围',
          type: 'string'
        }]
      };
    },
    /**
     * 获取地点管理表表单结构
     */
    pointStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.pstructList = JSON.parse(JSON.stringify(res));
        this.pList = getformatstruct(res, this.pform, this.pformlabel, this.pformfield, this.pformoption);
        this.pform[4] = [];
        this.pform.banner = [];
        this.pform.audio = [];
        this.pform.video = [];
        this.pform.audiodesc = [];
        this.defaultpform = Object.assign({}, this.pform);
        console.log(`this.pformlabel`, this.pformlabel);
        console.log(`this.defaultpform`, this.defaultpform);
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(typeclick) {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1 && !typeclick) that.pointList = [];
          that.pointdataformat(res, typeclick);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
          // if (res.totalPage >= that.pointform.page) that.getpointData()
        }
      });
    },
    pointdataformat(res, typeclick) {
      console.log(`res`, res);
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        // 判断点位样式字段  存在即赋值
        if (itemformat.seniorset !== undefined && itemformat.seniorset !== '') {
          itemformat.seniorset = {
            ...JSON.parse(itemformat.seniorset.replace(/(<\/?p.*?>)/gi, ''))
          };
        }
        item.itemformdata = itemformat;
      });
      this.pointList = this.pointform.page === 1 ? res.dataList : this.pointList.concat(res.dataList);
      this.mappointList = this.pointform.page === 1 ? res.dataList : this.mappointList.concat(res.dataList);
      console.log(`this.pointList`, this.pointList);
      // this.mappointList = [...this.pointList]
    },
    /**
     * 点位点击操作
    * @param {Object} val type 0添加、1编辑、2查询 3删除 | data 数据
     */
    pointHandle(val) {
      console.log(`val`, val);
      this.pointType = val;
      const currentPoint = _.cloneDeep(val);
      if (currentPoint.type === 0) {
        this.pisAdd = true;
        // 添加时 传入全局高级设置样式
        this.defaultpform.defaultseniorset = {
          text: {
            ...this.jsonOption.style.pointtext
          },
          pic: {
            ...this.jsonOption.style.pointpic
          },
          icon: {
            ...this.jsonOption.style.pointicon
          },
          pointStyleIndex: this.jsonOption.style.pointStyleIndex
        };
        this.pform = {
          ...this.defaultpform
        };
      }
      if (currentPoint.type === 1) {
        this.pisAdd = false;
        // 添加时 传入全局高级设置样式
        currentPoint.data.itemformdata.defaultseniorset = {
          text: {
            ...this.jsonOption.style.pointtext
          },
          pic: {
            ...this.jsonOption.style.pointpic
          },
          icon: {
            ...this.jsonOption.style.pointicon
          },
          pointStyleIndex: this.jsonOption.style.pointStyleIndex
        };
        currentPoint.data.itemformdata.id = val.data.id;
        this.pform = {
          ...currentPoint.data.itemformdata
        };
      }
      if (currentPoint.type === 2) this.searchpoint(currentPoint);
      if (currentPoint.type === 3) this.deletepoint(currentPoint.data);
      if (currentPoint.type === 2 || currentPoint.type === 3) return;
      this.$refs.pointdata.pointopen();
    },
    /**
     * 点位查询操作
    * @param {Object} val type 0添加、1编辑、2查询 3删除 | data 数据
     */
    searchpoint(val) {
      let isHasname = this.searchStr.filters[0].filters.find(elem => {
        return elem.alias === 'place_name';
      });
      if (val.data) {
        if (isHasname) {
          this.searchStr.filters[0].filters[1].val = val.data;
        } else {
          this.searchStr.filters[0].filters.push({
            alias: 'place_name',
            compt: 'editinput',
            express: 'like',
            val: val.data
          });
        }
      } else {
        if (isHasname) this.searchStr.filters[0].filters = this.searchStr.filters[0].filters.filter(elem => {
          return elem.alias !== 'place_name';
        });
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.mappointList = [];
      this.getpointData();
    },
    /**
     * 点位保存操作
    * @param {Object} val form数据
     */
    savePointHandle(val) {
      console.log(val);
      let that = this;
      let dataList = [];
      Object.keys(val).forEach(elem => {
        this.pList.forEach(child => {
          if (this.pisAdd && val[elem].toString().length === 0) return;
          if (elem === child.alias) {
            switch (child.compt) {
              case 'imagebox':
              case 'fileupload':
              case 'videobox':
              case 'location':
                child.values = formfileHandle(val[elem], child.compt, this.query.uid);
                break;
              default:
                child.values[0].val = val[elem];
                break;
            }
            dataList.push(child);
          }
        });
      });
      console.log(dataList);
      // 0添加
      if (this.pointType.type === 0) {
        dataList.push({
          alias: 'onlyid',
          compt: 'autonumber',
          values: [{
            'val': ''
          }]
        });
        dataList.push({
          alias: 'title',
          compt: 'editinput',
          values: [{
            'val': this.formatData.onlyid
          }]
        });
        dataList.push({
          alias: '40',
          compt: 'selectbox',
          values: [{
            'val': this.formatData.title
          }]
        });
        console.log(111);
        let formData = {
          deptId: this.query.fid,
          formId: 165054,
          uid: this.query.uid
        };
        this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
          ElNotification({
            message: '添加成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.mapmodule.removeAlliconsource();
            that.$refs.pointdata.pointclose();
            that.pointform.page = 1;
            that.pointList = [];
            that.getpointData();
          }, 2500);
        });
      }
      // 1编辑
      if (this.pointType.type === 1) {
        console.log(222);
        console.log(this.pointType.data);
        this.$api.editForm(this.query.fid, this.pointType.data.id, encodeURI(JSON.stringify(dataList)), this.pointType.data.formId).then(res => {
          ElNotification({
            message: '保存成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.mapmodule.removeAlliconsource();
            that.$refs.pointdata.pointclose();
            that.pointform.page = 1;
            that.pointList = [];
            that.getpointData();
          }, 2500);
        });
      }
    },
    /**
     * 点位删除操作
    * @param {Object} item 表单行数据
     */
    deletepoint(item) {
      console.log(item);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let deleteform = {
          formId: item.formId,
          formUserId: item.id
        };
        this.$api.deleteFormdata(deleteform).then(res => {
          if (res.status === 40101) {
            ElMessage({
              message: res.message,
              type: 'warning'
            });
          } else {
            ElMessage({
              message: '删除成功',
              type: 'success'
            });
            setTimeout(() => {
              that.$refs.mapmodule.removeAlliconsource();
              that.pointform.page = 1;
              that.pointList = [];
              that.mappointList = [];
              that.getpointData();
            }, 2500);
          }
        });
      }).catch(() => {});
    },
    /**
     * 获取分类管理表表单结构
     */
    typeStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 260297
      };
      this.$api.formStruct(params).then(res => {
        this.tstructList = JSON.parse(JSON.stringify(res));
        this.tList = getformatstruct(res, this.tform, this.tformlabel, this.tformfield, this.tformoption);
        this.tform.children = [];
        this.tform.sortId = 0;
        this.tform[3] = [];
        this.defaulttform = Object.assign({}, this.tform);
      });
    },
    /**
     * 获取分类列表数据
     */
    gettypeList() {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '3',
            'compt': 'selectbox',
            'express': '===',
            'val': [this.formatData.title]
          }]
        }]
      };
      this.typeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.typeform.deptId = this.query.fid;
      console.log(this.typeform);
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        console.log(res);
        if (res.totalRow > 0) {
          that.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          if (!this.style.typeall) {
            this.searchStr.filters.push({
              "model": 0,
              "filters": [{
                'alias': 'map_type2',
                'compt': 'editinput',
                'express': this.query.fid !== '2226' ? 'like' : '===',
                'val': this.typeList[0].itemformdata.title
              }]
            });
          }
          console.log(`this.typeList`, this.typeList);
        }

        // this.$refs.mapv2assembly.removeAlliconsource()
        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = this.formatData.title || this.formatData['46'];
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.getpointData();

        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          let searchStr = {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': 'correlation_map',
                'compt': 'selectbox',
                'express': '===',
                'val': ['是']
              }]
            }]
          };
          this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
          this.culturalform.deptId = this.query.fid;
          this.getIntangibleCulturalHeritageData();
        }
        this.getroutetypeList();
      });
    },
    /**
     * 分类点击操作
    * @param {Object} val type 0添加、1编辑、2查询 3删除 | data 数据
     */
    typeHandle(val) {
      console.log(val);
      this.mapType = val;
      if (val.type === 0) {
        this.tisAdd = true;
        this.tform = {
          ...this.defaulttform
        };
      }
      if (val.type === 1) {
        this.tisAdd = false;
        this.tform = {
          ...val.data.itemformdata
        };
        console.log(this.tform);
      }
      if (val.type === 3) {
        this.deletetype(val.data);
        return false;
      }
      this.$refs.typedata.typeopen();
    },
    /**
     * 类型保存操作
    * @param {Object} val form数据
     */
    savetypeHandle(val) {
      console.log(val);
      let that = this;
      let dataList = [];
      if (this.mapType.type === 0) {
        dataList.push({
          alias: 'json',
          compt: 'richtext',
          values: [{
            'val': `<p element-id=\"init\" style="display: none;">${JSON.stringify(val.children)}</p>`
          }]
        });
      }
      if (this.mapType.type === 1) {
        val.json = `<p element-id=\"init\" style="display: none;">${JSON.stringify(val.children)}</p>`;
      }
      Object.keys(val).forEach(elem => {
        this.tList.forEach(child => {
          if (this.tisAdd && val[elem].toString().length === 0) return;
          if (elem === child.alias) {
            switch (child.compt) {
              case 'imagebox':
                child.values = formfileHandle(val[elem], child.compt, this.query.uid);
                break;
              default:
                child.values[0].val = val[elem];
                break;
            }
            dataList.push(child);
          }
        });
      });
      console.log(dataList);
      // 0添加
      if (this.mapType.type === 0) {
        dataList.push({
          alias: 'onlyid',
          compt: 'editinput',
          values: [{
            'val': ''
          }]
        });
        console.log(dataList);
        let formData = {
          deptId: this.query.fid,
          formId: 260297,
          uid: this.query.uid
        };
        this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
          ElNotification({
            message: '添加成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.mapmodule.removeAlliconsource();
            that.$refs.typedata.typeclose();
            that.typeform.page = 1;
            that.typeList = [];
            that.gettypeList();
          }, 2500);
        });
      }
      // 1编辑
      if (this.mapType.type === 1) {
        console.log(222);
        console.log(dataList);
        this.$api.editForm(this.query.fid, this.mapType.data.id, encodeURI(JSON.stringify(dataList)), this.mapType.data.formId).then(res => {
          ElNotification({
            message: '保存成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.mapmodule.removeAlliconsource();
            that.$refs.typedata.typeclose();
            that.typeform.page = 1;
            that.typeList = [];
            that.gettypeList();
          }, 2500);
        });
      }
    },
    /**
     * 类型删除操作
    * @param {Object} item 表单行数据
     */
    deletetype(item) {
      console.log(item);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let deleteform = {
          formId: item.formId,
          formUserId: item.id
        };
        this.$api.deleteFormdata(deleteform).then(res => {
          if (res.status === 40101) {
            ElMessage({
              message: res.message,
              type: 'warning'
            });
          } else {
            ElMessage({
              message: '删除成功',
              type: 'success'
            });
            setTimeout(() => {
              that.$refs.mapmodule.removeAlliconsource();
              that.typeform.page = 1;
              that.gettypeList();
            }, 2500);
          }
        });
      }).catch(() => {});
    },
    /**
     * 点击类型操作
    * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      console.log(data);
      this.$refs.mapmodule.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? '' : data.item.itemformdata;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') this.searchStr.filters.splice(index, 1);
        });
      } else {
        this.searchStr.filters.forEach(item => {
          console.log(item);
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type2',
              'compt': 'editinput',
              'express': this.query.fid !== '2226' ? 'like' : '===',
              'val': val.title
            }]
          });
        }
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.mappointList = [];
      this.getpointData(true);
      this.$refs.mapmodule.closeHandle();
    },
    /**
     * 地图缩放事件
    * @param {Object} val 缩放层级
     */
    markermoveend(val) {
      console.log('markermoveend');
      console.log(val);
      console.log(this.mapv2info);
      this.style = _.cloneDeep(this.mapv2info.style);
      this.$refs.mapmodule.removeAlliconsource();
      let zoom = val;
      let minZoom = this.viewInfo.minZoom;
      if (this.isMobile) {
        let Difference = Math.round(this.mapv2info.screen.pc.view.zoom) - Math.round(this.mapv2info.screen.app.view.zoom);
        zoom += Difference;
      }
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '===',
          'val': i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.model === 1) item.filters = orData;
      });
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.mappointList = [];
      this.getpointData();
      if (this.cTemplateScore === 1) {
        this.culturalform.page = 1;
        this.getIntangibleCulturalHeritageData();
        if (this.isMobile) this.$refs.mapmodule.removeDrawsource();
      }
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        if (res === '表单不存在') {
          this.culturalform.formId = this.culturalformV2.formId;
          this.culturalform.t = this.culturalformV2.t;
          this.getIntangibleCulturalHeritageData();
          return;
        }
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) {
            that.culturalList = [];
            that.culturaltransferList = [];
          }
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.culturalform.page) that.getIntangibleCulturalHeritageData();
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = type.itemformdata.icon[0].fileUrl;
        }
        if (itemformat.correlation_picture !== undefined) {
          const picture = itemformat.correlation_picture;
          if (picture.length > 0 && picture[0].fileUrl) itemformat.icon = getImg(picture[0]);
        }
        item.itemformdata = itemformat;
        this.culturaltransferList.push({
          key: item.id,
          label: itemformat.title
        });
      });
      this.culturalList = this.culturalform.page === 1 ? res.dataList : this.culturalList.concat(res.dataList);
      // console.log(`culturalList`);
      // console.log(this.culturalList);
      // console.log(this.culturaltransferList);
    },
    /**
     * 显隐配置栏
     */
    launchHandle(val) {
      if (this.isMobile) return;
      this.mainActive = !val;
    },
    /**
     * 切换PC端移动端
     */
    changeScreen(val) {
      console.log(`------ changeScreen 切换PC端移动端 -------`);
      let defaultflag = true;
      this.isMobile = val;
      console.log(`this.mapv2info`, this.mapv2info);
      console.log(this.form);
      let editInfo = {
        style: _.cloneDeep(this.mapv2info.style),
        view: _.cloneDeep(this.mapv2info.view),
        senior: _.cloneDeep(this.mapv2info.senior),
        drawlayer: _.cloneDeep(this.mapv2info.drawlayer)
      };
      if (Object.keys(this.mapv2info.screen).length === 0) {
        defaultflag = false;
        this.SET_MAPINFOITEM({
          screen: {
            pc: _.cloneDeep(editInfo),
            app: _.cloneDeep(editInfo)
          }
        });
      } else {
        editInfo = {
          style: _.cloneDeep(this.mapv2info.style),
          view: _.cloneDeep(this.mapv2info.view),
          senior: _.cloneDeep(this.mapv2info.senior),
          drawlayer: _.cloneDeep(this.mapv2info.drawlayer)
        };
      }
      let cInfo = {};
      if (val) {
        document.querySelector('html').style.fontSize = `37.5px`;
        if (defaultflag) this.SET_MAPSCREENITEM({
          pc: _.cloneDeep(editInfo)
        });
        cInfo = _.cloneDeep(this.mapv2info.screen.app);
        console.log(`cInfo`, cInfo);
        if (this.mapv2info.form.app_static_img !== undefined && this.mapv2info.form.app_static_img.length === 0) {
          this.form.app_static_img = [...this.form.static_img];
        }
        this.maplayer.staticimage = this.form.app_static_img[0].fileUrl;
      } else {
        document.querySelector('html').style.fontSize = '';
        this.SET_MAPSCREENITEM({
          app: _.cloneDeep(editInfo)
        });
        cInfo = _.cloneDeep(this.mapv2info.screen.pc);
        console.log(`cInfo`, cInfo);
      }
      this.mapviewhandle(cInfo.view);
      this.form.showtype = cInfo.style.showtype;
      this.form.showlistflag = cInfo.style.showlistflag ? cInfo.style.showlistflag : 2;
      this.form.scale = cInfo.view.scale;
      this.form.rotate = cInfo.view.rotate;
      this.form.translate = cInfo.view.translate;
      // this.SET_MAPFORM(this.form)
      // this.SET_MAPSENIOR(cInfo.senior)
      this.senior = cInfo.senior;
      // this.SET_MAPSTYLE(_.cloneDeep(cInfo.style))
      this.style = cInfo.style;
      // 若点位编辑窗口打开，同步更新全局默认样式，确保 pointdata 切换平台时能正确回退
      if (this.$refs.pointdata && this.$refs.pointdata.pointShow) {
        this.pform.defaultseniorset = {
          text: cInfo.style.pointtext ? {
            ...cInfo.style.pointtext
          } : {},
          pic: cInfo.style.pointpic ? {
            ...cInfo.style.pointpic
          } : {},
          icon: cInfo.style.pointicon ? {
            ...cInfo.style.pointicon
          } : {},
          pointStyleIndex: cInfo.style.pointStyleIndex !== undefined ? cInfo.style.pointStyleIndex : 0
        };
      }
      console.log(this.style);
      this.viewInfo = cInfo.view;
      this.SET_MAPVIEW(cInfo.view);
      this.SET_MAPSTYLEITEM({
        showlistflag: cInfo.style.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        showtype: cInfo.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        pointStyleIndex: cInfo.style.pointStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        popStyleIndex: cInfo.style.popStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        typeStyleIndex: cInfo.style.typeStyleIndex
      });
      this.SET_MAPSTYLEITEM({
        listStyleIndex: cInfo.style.listStyleIndex
      });

      /* 图片组件 切换PC端移动端操作 */
      this.domeditorHide();
      if (this.isMobile) {
        // 移动端
        this.editorData.List = _.cloneDeep(this.ceditorData);
        this.ceditorData = _.cloneDeep(this.editorData.appList);
      } else {
        // PC端
        this.editorData.appList = _.cloneDeep(this.ceditorData);
        this.ceditorData = _.cloneDeep(this.editorData.List);
      }
      this.$refs.domeditor.resetNode(this.ceditorData);
    },
    changeTypeOrder(val) {
      this.searchStr.filters = this.searchStr.filters.filter(item => {
        return item.filters.length > 0 && item.filters[0]['alias'] === '40';
      });
      if (!val) {
        this.searchStr.filters.push({
          "model": 0,
          "filters": [{
            'alias': 'map_type2',
            'compt': 'editinput',
            'express': this.query.fid !== '2226' ? 'like' : '===',
            'val': this.typeList[0].itemformdata.title
          }]
        });
      }
      this.markermoveend(this.viewInfo.zoom);
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    /**
     * 获取分类管理表表单结构
     */
    routetypeStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 1626580
      };
      this.$api.formStruct(params).then(res => {
        this.rtstructList = _.cloneDeep(res);
        this.rtList = getformatstruct(res, this.rtform, this.rtformlabel, this.rtformfield, this.rtformoption);
        this.rtform.sortId = 0;
        this.defaultrtform = _.cloneDeep(this.rtform);
      });
    },
    /**
     * 获取路线分类列表数据
     */
    getroutetypeList() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          that.rtypeList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.getrouteData();
        }
        // 若无数据 新增默认分类
        if (that.rtypeform.page === 1 && res.totalRow === 0) {
          let dataList = [{
            "alias": "title",
            "compt": "editinput",
            "values": [{
              "val": "默认"
            }]
          }, {
            "alias": 'sortId',
            "compt": 'numberinput',
            "values": [{
              "val": 0
            }]
          }, {
            "alias": "onlyid",
            "compt": "autonumber",
            "values": [{
              "val": ""
            }]
          }, {
            "alias": "mapbelong",
            "compt": "selectbox",
            "values": [{
              "val": this.formatData.title
            }]
          }, {
            "alias": "mapbelongId",
            "compt": "editinput",
            "values": [{
              "val": this.formatData.onlyid
            }]
          }];
          let formData = {
            deptId: this.query.fid,
            formId: 1626580,
            uid: this.query.uid
          };
          this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
            setTimeout(() => {
              that.$refs.routetype.typeclose();
              that.rtypeform.page = 1;
              that.rtypeList = [];
              that.getroutetypeList();
            }, 2500);
          });
        }
      });
    },
    /**
     * 类型保存操作
    * @param {Object} val form数据
     */
    saveroutetypeHandle(val) {
      console.log(val);
      let that = this;
      let dataList = [];
      Object.keys(val).forEach(elem => {
        this.rtList.forEach(child => {
          if (this.rtisAdd && val[elem].toString().length === 0) return;
          if (elem === child.alias) {
            child.values[0].val = val[elem];
            dataList.push(child);
          }
        });
      });
      // 0添加
      if (this.maprouteType.type === 0) {
        dataList.push({
          alias: 'onlyid',
          compt: 'autonumber',
          values: [{
            'val': ''
          }]
        });
        dataList.push({
          alias: 'mapbelong',
          compt: 'selectbox',
          values: [{
            'val': this.formatData.title
          }]
        });
        dataList.push({
          alias: 'mapbelongId',
          compt: 'editinput',
          values: [{
            'val': this.formatData.onlyid
          }]
        });
        console.log(dataList);
        let formData = {
          deptId: this.query.fid,
          formId: 1626580,
          uid: this.query.uid
        };
        this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
          ElNotification({
            message: '添加成功',
            type: 'success'
          });
          that.updaterouteTypeList();
        });
      }
      // 1编辑
      if (this.maprouteType.type === 1) {
        console.log(dataList);
        this.$api.editForm(this.query.fid, this.maprouteType.data.id, encodeURI(JSON.stringify(dataList)), this.maprouteType.data.formId).then(res => {
          ElNotification({
            message: '保存成功',
            type: 'success'
          });
          that.updaterouteTypeList();
        });
      }
    },
    /**
     * 路线分类点击操作
    * @param {Object} val type 0添加、1编辑、2查询 3删除 | data 数据
     */
    routetypeHandle(val) {
      console.log(val);
      this.maprouteType = val;
      if (val.type === 0) {
        this.rtisAdd = true;
        this.rtform = {
          ...this.defaultrtform
        };
      }
      if (val.type === 1) {
        this.rtisAdd = false;
        this.rtform = {
          ...val.data.itemformdata
        };
        this.rtform.sortId = Number(this.rtform.sortId);
      }
      if (val.type === 3) {
        this.routedeletetype(val.data);
        return false;
      }
      this.$refs.routetype.typeopen();
    },
    /**
     * 类型删除操作
    * @param {Object} item 表单行数据
     */
    routedeletetype(item) {
      console.log(item);
      console.log(this.routeList);
      let deleteids = [];
      let drouteformId = '';
      this.routeList.forEach(elem => {
        if (elem.itemformdata.typeId === item.itemformdata.onlyid) {
          drouteformId = elem.formId;
          deleteids.push(elem.id);
        }
      });
      console.log(deleteids);
      let that = this;
      ElMessageBox.confirm('确定要删除该分类及分类下的路线么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$api.deleteFormdata({
          formId: item.formId,
          formUserId: item.id
        }).then(res => {
          if (res.status === 40101) {
            ElMessage({
              message: res.message,
              type: 'warning'
            });
          } else {
            this.$api.deleteFormdata({
              formId: drouteformId,
              formUserId: deleteids.join(',')
            }).then(res => {
              if (res.status === 40101) {
                ElMessage({
                  message: res.message,
                  type: 'warning'
                });
              } else {
                ElMessage({
                  message: '删除成功',
                  type: 'success'
                });
                that.updaterouteTypeList();
              }
            });
          }
        });
      }).catch(() => {});
    },
    updaterouteTypeList() {
      this.timer = setTimeout(() => {
        this.$refs.routetype.typeclose();
        this.rtypeform.page = 1;
        this.rtypeList = [];
        this.getroutetypeList();
        clearTimeout(this.timer);
        this.timer = null;
        console.log(`this.timer`, this.timer);
      }, 2500);
    },
    /**
     * 获取路线管理表表单结构
     */
    routeStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 1626576
      };
      this.$api.formStruct(params).then(res => {
        this.rstructList = _.cloneDeep(res);
        this.rList = getformatstruct(res, this.rform, this.rformlabel, this.rformfield, this.rformoption);
        this.defaultrform = _.cloneDeep(this.rform);
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      this.routeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.routeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.routeList = [];
          let dataList = that.formdataformat(res);
          that.routeList = that.routeform.page === 1 ? dataList : that.routeList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    /**
     * 路线点击操作
    * @param {Object} val type 0添加、1编辑、2查询 3删除 | data 数据
     */
    routehandle(val) {
      this.routehType = val;
      if (val.type === 0) {
        this.risAdd = true;
        this.rform = {
          ...this.defaultrform
        };
        if (val.data) {
          this.rform.type = val.data.itemformdata.onlyid;
        }
      }
      if (val.type === 1) {
        this.risAdd = false;
        this.rform = {
          ...val.data.itemformdata
        };
      }
      if (val.type === 3) this.deleteroute(val.data);
      if (val.type === 2 || val.type === 3) return;
      this.$refs.mapmodule.routeshow(true);
      this.$refs.routedata.routeopen();
    },
    /* 清除路线 显示原点位数据 */
    clearRoutesource() {
      this.$refs.mapmodule.setRoutePoint(this.pointList);
    },
    /**
     * 路线保存操作
    * @param {Object} val form数据
     */
    saveRouteHandle(val) {
      console.log(val);
      let that = this;
      let dataList = [];
      Object.keys(val).forEach(elem => {
        this.rList.forEach(child => {
          if (this.risAdd && val[elem].toString().length === 0) return;
          if (elem === child.alias) {
            child.values[0].val = val[elem];
            dataList.push(child);
          }
        });
      });
      // 0添加
      if (this.routehType.type === 0) {
        dataList.push({
          alias: 'onlyid',
          compt: 'autonumber',
          values: [{
            'val': ''
          }]
        });
        dataList.push({
          alias: 'mapbelong',
          compt: 'selectbox',
          values: [{
            'val': this.formatData.title
          }]
        });
        dataList.push({
          alias: 'mapbelongId',
          compt: 'editinput',
          values: [{
            'val': this.formatData.onlyid
          }]
        });
        let formData = {
          deptId: this.query.fid,
          formId: 1626576,
          uid: this.query.uid
        };
        console.log(dataList);
        this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
          ElNotification({
            message: '添加成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.routedata.routeclose();
            that.routeform.page = 1;
            that.routeList = [];
            that.getrouteData();
            that.clearRoutesource();
          }, 2500);
        });
      }
      // 1编辑
      if (this.routehType.type === 1) {
        this.$api.editForm(this.query.fid, this.routehType.data.id, encodeURI(JSON.stringify(dataList)), this.routehType.data.formId).then(res => {
          ElNotification({
            message: '保存成功',
            type: 'success'
          });
          setTimeout(() => {
            that.$refs.routedata.routeclose();
            that.routeform.page = 1;
            that.routeList = [];
            that.getrouteData();
            that.clearRoutesource();
          }, 2500);
        });
      }
    },
    /**
     * 路线删除操作
    * @param {Object} item 表单行数据
     */
    deleteroute(item) {
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let deleteform = {
          formId: item.formId,
          formUserId: item.id
        };
        this.$api.deleteFormdata(deleteform).then(res => {
          if (res.status === 40101) {
            ElMessage({
              message: res.message,
              type: 'warning'
            });
          } else {
            ElMessage({
              message: '删除成功',
              type: 'success'
            });
            setTimeout(() => {
              that.routeform.page = 1;
              that.routeList = [];
              that.getrouteData();
            }, 2500);
          }
        });
      }).catch(() => {});
    },
    /* 切换左侧导航事件 */
    switchNav(index) {
      if (index === 2) this.$refs.typedata.typeclose();
      if (index === 3) this.$refs.pointdata.pointclose();
      if (index === 7) {
        this.$refs.routedata.routeclose();
        this.$refs.mapmodule.setRoutePoint(this.pointList);
      }
    },
    /* 点击路线显示相应点位 */
    getRoutePoint(val) {
      this.$refs.mapmodule.setRoutePoint(val);
    },
    /* 图片组件鼠标拖操作 */
    pichandleDragStart(event, item) {
      console.log(`pichandleDragStart`, event);
      this.dragData = item;
      this.mx = event.offsetX;
      this.my = event.offsetY;
    },
    /* 图片组件鼠标放操作 */
    pichandleDrop(event) {
      event.preventDefault();
      let id = event.dataTransfer.getData('text/plain');
      console.log(`pichandleDrop`, id);
      if (this.dragData.type === 'picture') {
        if (Number(id) !== 0) return;
        this.addpicItem(event);
        /* 打开右侧内容管理 */
        this.opendragcontent();
        /* 显示dom编辑器 */
        this.domeditorflag = true;
      }
      if (this.dragData.type === 'decortaion') {
        console.log(`pichandleDrop`, event);
        // 获取被放置元素的位置
        const left = event.offsetX - this.mx; // 相对于目标元素的left
        const top = event.offsetY - this.my; // 相对于目标元素的top
        const pointdata = {
          ...this.dragData.data,
          left: left,
          top: top
        };
        this.$refs.mapmodule.setDecorationpoint(pointdata);
      }
    },
    opendragcontent() {
      this.$refs.dragcontent.open();
    },
    hidedragcontent() {
      this.$refs.dragcontent.close();
    },
    addpicItem(event) {
      console.log(`pichandleDrop`, event);
      // 获取被放置元素的位置
      const left = event.offsetX - this.mx; // 相对于目标元素的left
      const top = event.offsetY - this.my; // 相对于目标元素的top
      /* dom编辑器新增事件 */
      this.$refs.domeditor.addNode({
        x: left,
        y: top,
        type: 'Image'
      });
    },
    domeditorHide() {
      console.log(`------ 隐藏dom编辑器 -------`);
      this.domeditorflag = false;
      this.hidedragcontent();
    },
    /* dom编辑器选择改变Node返回数据 */
    selectNodeHandle(val) {
      console.log(`------ dom编辑器选择改变Node返回数据 -------`);
      console.log(`selectNodeHandle`, val);
      this.opendragcontent();
      let id = val.getAttr('id');
      console.log(`id`, id);
      console.log(`this.dragNode`, this.dragNode);
      console.log(`this.ceditorData`, this.ceditorData);
      if (this.dragNode.id === id) {
        this.dragNode.style = val.getAttrs();
        return;
      }
      this.ceditorData.forEach(data => {
        if (data.id === id) this.dragNode = data;
      });
    },
    /* dom编辑器新增返回数据 */
    addNodeHandle(val) {
      console.log(`------ dom编辑器新增返回数据 -------`);
      console.log(`addNodeHandle`, val);
      this.dragNode = val;
      this.ceditorData.push(this.dragNode);
      this.saveEditorData();
      console.log(`this.ceditorData`, this.ceditorData);
    },
    /* dom编辑器改变node结束时数据 */
    savetrEndNodeHandle(val) {
      console.log(`------ dom编辑器改变node结束时数据 -------`);
      console.log(`savetrEndNodeHandle`, val);
      let id = val.getAttr('id');
      this.ceditorData.forEach(data => {
        if (data.id === id) {
          data.style = val.getAttrs();
          this.dragNode = data;
        }
      });
      this.saveEditorData();
    },
    /* superMap 点击dom事件 */
    mapNodeclick(item) {
      console.log(`------ superMap 点击dom事件 -------`);
      this.domeditorflag = true;
      this.$refs.domeditor.selectNode(item);
      this.opendragcontent();
    },
    /* 右侧内容管理 改变值触发 */
    changestyleHandle(val) {
      console.log(`------ index右侧内容管理 改变值触发 -------`);
      console.log(`mapv2info.domstyle`, val);
      this.dragNode.style = val.getAttrs();
      if (val.imagearr !== undefined && Object.prototype.toString.call(val.imagearr) === '[object Array]') this.dragNode.image = [...val.imagearr];
      if (val.link !== undefined) {
        let linkdata = {
          ...val.link
        };
        // if (linkdata.url !== '') linkdata.url = encodeURIComponent(linkdata.url)
        if (linkdata.url !== '') linkdata.url = linkdata.url.replace(/&/g, '；');
        this.dragNode.data = linkdata;
      }
      let id = val.getAttr('id');
      this.ceditorData.forEach(data => {
        if (data.id === id) data = this.dragNode;
      });
      this.saveEditorData();
      console.log(`this.ceditorData`, this.ceditorData);
    },
    deleteNodeHandle(val) {
      console.log(`------ dom编辑器删除数据 -------`);
      console.log(`deleteNodeHandle`, val);
      console.log(`this.ceditorData`, this.ceditorData);
      let id = val.getAttr('id');
      this.ceditorData = this.ceditorData.filter(data => data.id !== id);
      console.log(`this.ceditorData`, this.ceditorData);
      this.saveEditorData();
      this.hidedragcontent();
    },
    saveEditorData() {
      if (this.isMobile) {
        // 移动端
        this.editorData.appList = _.cloneDeep(this.ceditorData);
      } else {
        // PC端
        this.editorData.List = _.cloneDeep(this.ceditorData);
      }
    },
    /**
     * 单个点位样式改变事件
    * @param {Object} val 数据
     * @date 2025-06-04
     */
    pointstyleChange(val) {
      this.$refs.mapmodule.setPointStyle(val);
    },
    /**
     * 打开素材库
    * @param {Object} val 数据
     * @date 2025-06-04
     */
    openSourceMaterial(val) {
      console.log(`val`, val);
      if (val.type === 0) this.maplayer.tiles = false;
      this.$refs.sourcematerial.openSourceMaterial(val);
    },
    /**
     * 选择素材返回函数
    * @param {Object} val 数据
     * @date 2025-06-04
     */
    setSourceMaterial(val) {
      console.log(val);
      const data = val.data.itemformdata;
      console.log(`data.picture_upload`, data.picture_upload);
      switch (val.type) {
        case 0:
          if (!this.isMobile) {
            this.form.background_img = data.picture_upload;
          } else {
            this.form.app_bg_img = data.picture_upload;
          }
          break;
        case 2:
          this.$refs.slidedata.changetypePic(data);
          break;
        case 3:
          if (val.title === '图片库') this.$refs.pointdata.changeform4(data);
          if (val.title === '图标库') this.$refs.typedata.changePic(data);
          break;
        default:
      }
    },
    /**
     * 地图投影返回数据
    * @param {Object} val 数据
     * @date 2025-06-26
     */
    mapShadowList(data) {
      console.log(`mapShadowList`, data);
      if (data.shadowFlag === undefined) return;
      this.cMapShadowData = data;
      this.$refs.mapmodule.changeMapShadowList(data);
    },
    /**
     * 获取素材库表单结构
     * 挪到主页获取
     * @date 2025-07-10
     */
    getStructForm() {
      let that = this;
      let params = {
        deptId: '186266',
        formId: 2184030
      };
      this.$api.formStruct(params).then(res => {
        that.sourcestructList = _.cloneDeep(res);
      });
    },
    /**
     * 地图投影装饰点击操作
    * @param {Object} item 选中数据
     * @date 2025-07-10
     */
    decorationHandle(item) {
      this.$refs.mapdecortaion.openHandle(item);
    },
    /**
     * 获取本单位智能体
     * @date 2026-01-14
     */
    getRobotsByUnit() {
      const params = {
        unitId: this.query.fid
      };
      this.$whgapi.getRobotsByUnit(params).then(res => {
        console.log(`getRobotsByUnit`, res);
      });
    }
  }
};